import { IAppSettings } from "./components/App-Client/App-Client";
import { JsonUtils } from "threngine";

export class Initializer {
	private static _getSettingsFromRootDiv = (defaultSettings:IAppSettings):IAppSettings => {
		const rootDiv = document.getElementById(defaultSettings.rootDivId || "vc-threed-widget");
		
		if (!rootDiv) {
			const error = new Error("Could not find rootDiv with ID [ " + defaultSettings.rootDivId + " ]. Widget could not be initialized.")
			throw error;
		}
	
		const rootDivData = rootDiv.dataset || {};
	
		const appSettings:IAppSettings = {
			rootDivId: defaultSettings.rootDivId || "vc-threed-widget",
			assetPath: rootDivData.assetpath || defaultSettings.assetPath || "Assets/",
			productId: rootDivData.productid || defaultSettings.productId || "default",
			autoScaleUp: rootDivData.autoscaleup || defaultSettings.autoScaleUp || "true",
			autoScaleDown: rootDivData.autoscaledown || defaultSettings.autoScaleDown || "true",
		};

		// console.log("appSettings: ", appSettings);
	
		return appSettings;
	}
	
	static webGlAvailable = ():boolean => {
		try {
			var canvas = document.createElement("canvas");
			return !!
				( (<any>window).WebGLRenderingContext && (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")) );
		} catch(e) { 
			return false;
		} 
	}

	static getWidgetSettings = ():Promise<IAppSettings> => {
		//FIXME CRITICAL: THE ONE SINGLE HARDCODED URL
		return JsonUtils.loadUrl("https://s3.eu-central-1.amazonaws.com/ruwac/live/defaultSettings.json")
		.then((json) => {
			const defaultSettings:IAppSettings = {
				productId: json.productId,
				assetPath: json.assetPath,
				rootDivId: json.rootDivId,
				autoScaleUp: json.autoScaleUp,
				autoScaleDown: json.autoScaleDown,
			};

			return defaultSettings;
		}, (e) => { //onRejected
			console.error("Could not find defaultSettings.json! Using fallback values. | Error:", e);
			return {};
		})
		.then((defaultSettings) => {
			const widgetSettings = Initializer._getSettingsFromRootDiv(defaultSettings);

			return widgetSettings;
		})
	}
}